<template>
  <b-row class="mt-2">
    <b-col class="hospital-component">
      <b-button-group
        :class="{
          'd-none': isVoipCallInProgress,
          'd-flex': !isVoipCallInProgress,
        }"
      >
        <b-button
          ref="hospitalPicker"
          v-b-modal.hospital-picker
          block
          variant="light"
          :class="{
            'border border-success': hospitalName,
            'border border-warning': !hospitalName,
          }"
          class="border border-success"
          data-test-id="hospital-selector-button"
          style="position: relative"
        >
          <span
            v-if="!hospitalName"
            class="badge badge-warning hospital-selector-badge"
            data-test-id="hospital-unselected-badge"
            >Select destination</span
          >
          <span v-else class="badge badge-success hospital-selector-badge" data-test-id="hospital-selected-badge"
            >Case delivered to</span
          >
          <span class="hospital-selector-button" data-test-id="hospital-selector-button__text"
            >{{ hospitalName || "Choose Hospital to send case" }}
          </span>
        </b-button>
        <b-button v-if="showCallButton" variant="success" @click="showPhoneNumbers">
          <b-icon icon="telephone-fill"></b-icon>
        </b-button>
      </b-button-group>

      <PhoneList
        ref="PhoneList"
        :phone-numbers="hospitalPhones"
        :hospital-name="hospitalName"
        :non-twiage-hospital="nonTwiageHospital"
        @startCall="startCall"
      />

      <Voip ref="Voip" :hospital-name="hospitalName" :class="{ 'd-none': !isVoipCallInProgress }" />

      <b-modal
        id="hospital-picker"
        ref="hospital-picker"
        body-class="hospital-selector-modal"
        hide-footer
        hide-header
        data-test-id="hospital-selector-modal"
      >
        <div>
          <div class="hospital-selector-modal__header">Choose Hospital to send case.</div>
          <div class="hospital-selector-modal__info-text">Choose the hospital you're going to.</div>
          <div
            v-for="eachHospital in hospitals"
            :key="eachHospital._id"
            class="hospital-selector-cardx"
            role="button"
            tabindex="0"
            data-test-id="hospital-selector-card"
            @click="setHospital(eachHospital)"
            @keydown.enter="setHospital(eachHospital)"
          >
            <HospitalCard :this-hospital="eachHospital" />
          </div>
        </div>
      </b-modal>
    </b-col>
  </b-row>
</template>

<script>
import HospitalCard from "@/Case/components/HospitalCard.vue";
import Voip from "@/Case/voip/components/Voip";
import PhoneList from "@/Case/voip/components/DepartmentList";
import { CaseEvent, CaseUpdateEventType } from "@/Case/CaseEvent";
import { mapGetters } from "vuex";

export default {
  name: "Hospital",

  components: { PhoneList, Voip, HospitalCard },

  props: {
    hospitals: {
      required: true,
      type: Array,
      validator(value) {
        return value.length > 0 && value.every((item) => item?._id !== undefined && item?.name !== undefined);
      },
    },

    destinationHospital: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      hospital: null,
    };
  },

  computed: {
    ...mapGetters("Voip", {
      isVoipCallInProgress: "isCallInProgress",
    }),
    hospitalName() {
      return this.hospital?.name || null;
    },
    hospitalPhones() {
      return this.hospital?.edPhoneNumbers || [];
    },
    showCallButton() {
      return this.hospitalPhones?.length > 0;
    },
    nonTwiageHospital() {
      return this.hospital?.nonTwiage;
    },
  },

  mounted() {
    if (this.destinationHospital) {
      this.hospital = this.destinationHospital;
    }
  },

  methods: {
    showPhoneNumbers() {
      if (this.hospitalPhones.length === 1) {
        this.startCall(this.hospitalPhones[0]);
      } else {
        this.$refs.PhoneList.show();
      }
    },

    startCall(emergencyDepartment) {
      this.$refs.Voip.startCall(emergencyDepartment);
    },

    setHospital(hospital) {
      this.hospital = hospital;
      this.$emit(CaseEvent.MODIFY, {
        eventType: CaseUpdateEventType.hospital,
        data: this.hospital,
      });
      this.$refs["hospital-picker"].hide();
    },
  },
};
</script>

<style>
.hospital-selector-modal {
  background-color: black;
}
#hospital-picker .modal-content {
  background-color: #000;
}
</style>

<style scoped>
.hospital-selector-button {
  font-weight: bold;
}

@media screen and (max-width: 400px) {
  .hospital-selector-button {
    font-size: small;
  }
}

.hospital-selector-modal__header {
  color: #bbbbbb;
  font-size: 1.4rem;
  font-weight: bold;
  margin-bottom: 1.4rem;
  text-align: center;
}

.hospital-selector-modal__info-text {
  color: #bbbbbb;
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

.hospital-selector-card {
  align-items: center;
  background-color: #222222;
  border-radius: 6px;
  display: flex;
  margin-bottom: 1rem;
  padding: 1rem;
}

.hospital-selector-card:last-of-type {
  margin-bottom: 0.5rem;
}

.hospital-selector-card__twiage-logo {
  height: 40px;
}

.hospital-selector-card__phone {
  height: 30px;
  margin-left: 10px;
  margin-right: 24px;
}

.hospital-selector-card__name {
  color: #dddddd;
  font-weight: bold;
  padding-left: 5px;
}

.hospital-selector-badge {
  left: -3px;
  position: absolute;
  top: -10px;
}

.hospital-component .border {
  border: 3px solid !important;
}

.hospital-component .border-success {
  border-color: #28a745 !important;
}

.hospital-component .border-warning {
  border-color: #ffc107 !important;
}

.non-twiage {
  margin-right: 60px;
}

.non-twiage-hospital-subtext {
  font-size: 75%;
  font-weight: normal;
  color: grey;
}

.hospital-component {
  position: relative;
}
.hospital-statuses span {
  margin-right: 5px;
}
</style>
